import moment from 'moment'

export const formatPrice = (number: number, minimumFractionDigits: number | null = 2) => {
    const options = minimumFractionDigits === null ? {} : {minimumFractionDigits};
    return Number(number).toLocaleString("sk-SK", options);
};

export const formatDate = (date: string) => {
    return moment(date).format('DD.MM.YYYY');
};

export const formatDateTime = (date: string) => {
    return moment(date).format('DD.MM.YYYY HH:mm:ss');
};

export const validateForm = (form: any) => {
    form.validate();
    return form.errors.length === 0;
};

export const randomString = (length: number): string => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};